import React from "react";

import { useStaticQuery, graphql } from "gatsby";
import styled from "@emotion/styled";
import { Layout } from "../components/elements/container";
import { GridItemWithTransition } from "../components/collections/GridItemPeople";

const Grid = styled.ul`
  margin: 0;

  display: -ms-grid;
  display: grid;
  -ms-grid-columns: 1fr 2px 1fr 2px 1fr 2px 1fr 2px 1fr 2px 1fr;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 2px;
`;

const Item = styled.li`
  height: 100%;
  width: 100%;
  position: relative;
  font-size: 0;
  margin 0;

  &::before {
    content: " ";
    float: left;
    display: inline-block;
    width: 1px;
    margin-left: -1px;
    height: 0px;
    padding-top: 100%;
  }
`;

export const PeoplePanel = () => {
  const {
    allWordpressWpPeople: { nodes },
  } = useStaticQuery(graphql`
    {
      allWordpressWpPeople {
        nodes {
          title
          acf {
            people_location
            people_position
            people_hover_image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
            people_main_image {
              localFile {
                childImageSharp {
                  original {
                    src
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  return (
    <>
      <Layout>
        <Grid>
          {nodes.reverse().map((item, i) => (
            <Item key={i}>
              <GridItemWithTransition data={item} />
            </Item>
          ))}
        </Grid>
      </Layout>
    </>
  );
};
